import { Route, Routes } from 'react-router-dom';

import { Release } from './components/Release/Release';
import { Test } from './components/Test/Test';

const TestAndReleaseView = () => {
  return (
    <Routes>
      <Route path="/" element={<Test />} />
      <Route path="/test" index element={<Test />} />
      <Route path="/release" element={<Release />} />
    </Routes>
  );
};

export default TestAndReleaseView;
